<template>
  <v-app>
    <core-app-bar />

    <core-drawer />

    <core-view-dependents-view />

    <core-footer />

  </v-app>
</template>

<script>
export default {
  name: 'ViewDependents',

  components: {
    CoreAppBar: () => import('../components/core/AppBar'),
    CoreDrawer: () => import('../components/core/Drawer'),
    CoreViewDependentsView: () => import('../components/core/ViewDependentsView'),
    CoreFooter: () => import('../components/core/Footer'),
  },

  data: () => ({
    expandOnHover: false,
  }),
}
</script>
